import initMaskedInputs from 'javascripts/common/masked_input'

require('@rails/ujs').start()
require('turbolinks').start()
require('javascripts/channels')

$(document).on('turbolinks:load', () => {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover({ trigger: 'hover' })

  initMaskedInputs()
})
